var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inspector-action-line"},[_c(_setup.CompetenceCategoryIcon,{attrs:{"icon":_vm.competence_category}}),_c('span',{staticClass:"inspector-action-line-action-text"},[_vm._v(_vm._s(_vm.inspector_action))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }